(function () {
  function normalizeMenuLabel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function resolveMenuIconUrl(label) {
    const icons = (window.theme && window.theme.menuIcons) || {};
    const normalized = normalizeMenuLabel(label);

    if (!normalized) {
      return null;
    }

    if (icons[normalized]) {
      return icons[normalized];
    }

    const compact = normalized.replace(/\s+/g, '');
    if (icons[compact]) {
      return icons[compact];
    }

    return null;
  }

  function replaceGloboMenuIcons() {
    const icons = (window.theme && window.theme.menuIcons) || {};

    if (!Object.keys(icons).length) {
      return;
    }

    document.querySelectorAll('.gm-icon.gm-icon-img img').forEach((img) => {
      if (img.dataset.bsrIconReplaced === 'true') {
        return;
      }

      const label =
        img.getAttribute('title') ||
        img.getAttribute('alt') ||
        img.closest('a')?.getAttribute('title') ||
        img.closest('.gm-item')?.querySelector('.gm-text')?.textContent;

      const nextSrc = resolveMenuIconUrl(label);

      if (!nextSrc) {
        return;
      }

      img.src = nextSrc;
      img.removeAttribute('srcset');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.dataset.bsrIconReplaced = 'true';
    });
  }

  function customizeGloboMenu() {
    replaceGloboMenuIcons();

    const gridContainers = document.getElementsByClassName('gm-collections gm-grid');

    for (const container of gridContainers) {
      if (container.dataset.bsrCustomized === 'true') {
        continue;
      }

      if (
        (container.parentElement.classList.contains('gmcol-9') && container.children.length > 3) ||
        (container.parentElement.classList.contains('gmcol-12') && container.children.length > 4)
      ) {
        container.classList.add('gm-cards-stacked');
        container.style.gridTemplateColumns = `repeat(${
          container.parentElement.classList.contains('gmcol-9') ? 3 : 4
        }, 1fr)`;
        container.dataset.bsrCustomized = 'true';
      }
    }

    const gridImageContainers = document.getElementsByClassName('gm-tab-panel');

    for (const container of gridImageContainers) {
      if (container.dataset.bsrCustomized === 'true') {
        continue;
      }

      const imageContainer = container.getElementsByClassName('gm-image-1');

      if (imageContainer.length > 4 && imageContainer.length < 8) {
        const imageContainerArray = [...imageContainer];
        const gridImageElements = imageContainerArray.slice(0, imageContainerArray.length - 1);
        const bigImageElement = imageContainerArray[imageContainerArray.length - 1];
        const newDivGridElements = document.createElement('div');

        newDivGridElements.classList.add('gm-cards-image-grid-full');

        for (const gridImage of gridImageElements) {
          newDivGridElements.appendChild(gridImage);
        }

        bigImageElement.classList.add('gm-cards-image-isolated-full');
        container.classList.add('gm-cards-wrapper-grid-full');
        container.innerHTML = '';
        container.appendChild(newDivGridElements);
        container.appendChild(bigImageElement);
        container.dataset.bsrCustomized = 'true';
      }
    }
  }

  function getHeaderBottom() {
    const header = document.querySelector('[data-site-header]');

    if (!header) {
      return null;
    }

    return header.getBoundingClientRect().bottom;
  }

  function positionMegaSubmenus() {
    if (window.innerWidth < 768) {
      return;
    }

    const top = getHeaderBottom();

    if (top === null) {
      return;
    }

    document.querySelectorAll('.gm-item.gm-level-0 > .gm-submenu.gm-mega').forEach((submenu) => {
      submenu.style.top = `${top}px`;
    });
  }

  function bindMegaSubmenuPositioning() {
    if (window.innerWidth < 768) {
      return;
    }

    document.querySelectorAll('.gm-item.gm-level-0.gm-has-submenu').forEach((item) => {
      if (item.dataset.bsrMegaPositionBound === 'true') {
        return;
      }

      item.addEventListener('mouseenter', positionMegaSubmenus);
      item.addEventListener('focusin', positionMegaSubmenus);
      item.dataset.bsrMegaPositionBound = 'true';
    });

    positionMegaSubmenus();
  }

  function initGloboMenuCustomizations() {
    const app = document.getElementById('header-globo-mega-menu-app');

    if (!app) {
      return;
    }

    customizeGloboMenu();
    bindMegaSubmenuPositioning();

    if (!app.dataset.bsrObserverAttached) {
      const observer = new MutationObserver(() => {
        customizeGloboMenu();
        bindMegaSubmenuPositioning();
        positionMegaSubmenus();
      });

      observer.observe(app, { childList: true, subtree: true });
      app.dataset.bsrObserverAttached = 'true';
    }
  }

  function onLayoutChange() {
    initGloboMenuCustomizations();
    positionMegaSubmenus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGloboMenuCustomizations);
  } else {
    initGloboMenuCustomizations();
  }

  window.addEventListener('load', initGloboMenuCustomizations);
  window.addEventListener('resize', onLayoutChange);
  window.addEventListener('scroll', positionMegaSubmenus, { passive: true });
})();
